import { makeStyles } from "@material-ui/styles";

const personnelListStyles = makeStyles((theme) => ({
	listContent: {
		padding: theme.spacing(2, 1),
		borderRadius: "4px",
		backgroundColor: "#FAFAFA"
	},
	listItem: {
		paddingTop: 0
	}
}));

export default personnelListStyles;
